import parsePhoneNumber from 'libphonenumber-js';

export default {
    filters: {
        phoneFormatter(value) {
            if (lodash.isEmpty(value)) {
                return ''
            }

            return 'tel:' + parsePhoneNumber(value, 'NL').number;
        },

        emailFormatter(value) {
            if (lodash.isEmpty(value)) {
                return ''
            }

            return 'mailto:' + value;
        }
    }
}